// extracted by mini-css-extract-plugin
module.exports = {"LoadingRow":"LoadingRows_LoadingRow__Zt35n","moving-gradient":"LoadingRows_moving-gradient__2ZS9R"};